<modal #modal>
  <div class="info-personal-details-modal">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">Dine oplysninger</h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCloseClick()"></button>
    </div>

    <div class="modal-body">
      <p class="fw-bold pb-2">Hvad bruger I mine oplysninger til?</p>
      <p>
        I Klasselotteriet anvender vi dine personlige oplysninger til at oprette dig som kunde i vores system. Det er i
        den forbindelse vigtigt for os, at dine informationer bliver udfyldt korrekt.<br>
        Dit CPR-nummer bruger vi til at oprette din adgang til 'Min side', hvor du løbende kan skabe overblik over dit
        spil.
      </p>
      <p class="fw-bold py-2">Spillemyndigheden</p>
      <p>
        Det er os pålagt af Spillemyndigheden at indhente dit CPR-nummer til sammenkobling af din spillerprofil og MitID,
        for at dine oplysninger er så sikre som muligt.
      </p>
      <p class="fw-bold  py-2">Vidste du, at...</p>
      <p>
        I henhold til Spillemyndigheden retningslinjer, varetager Klasselotteriet rollen som dataansvarlig for dine
        stamdata. Vi arbejder hele tiden på at sikre, at dine oplysninger holdes fortroligt, så de lever op til vores
        persondatapolitik og GDPR.
      </p>
      <p class="fw-bold py-2">Kontakt Kundeservice</p>
      <p
        >Ønsker du hjælp til bestilling af lodder - så kontakt kundeservice via vores chat, 
        <a class="link" href="mailto:kundeservice@klasselotteriet.dk">e-mail</a> 
        eller telefon: <a class="link" href="tel:33420900">3342 0900</a>
      </p>
    </div>
  </div>
</modal>
